module.exports = __webpack_public_path__ + "img/skiing.00630399.png";